import { Link } from '@remix-run/react'
import { CheckIcon } from 'lucide-react'
import { cn } from '#app/utils/misc.tsx'
import { Button } from './ui/button'
import { Card, CardContent, CardFooter, CardHeader } from './ui/card'
interface PricingPlanProps {
	name: string
	price: string
	description: string
	features: string[]
	featured?: boolean
	href: string
}

export function PricingPlan({
	name,
	price,
	description,
	features,
	featured = false,
	href,
}: PricingPlanProps) {
	return (
		<Card
			className={cn(
				'relative flex flex-col',
				featured && 'scale-105 border-primary shadow-lg',
			)}
		>
			{featured && (
				<div className="absolute -top-5 left-0 right-0 mx-auto w-fit">
					<span className="rounded-full bg-primary px-3 py-1 text-sm text-primary-foreground">
						Popular
					</span>
				</div>
			)}

			<CardHeader>
				<div className="space-y-2">
					<h3 className="text-2xl font-bold">{name}</h3>
					<p className="text-muted-foreground">{description}</p>
				</div>
			</CardHeader>

			<CardContent className="grid gap-4">
				<div className="text-center">
					<span className="text-4xl font-bold">{price}</span>
					<span className="text-muted-foreground">/month</span>
				</div>

				<ul className="space-y-2">
					{features.map(feature => (
						<li key={feature} className="flex items-center gap-2">
							<CheckIcon
								className={cn(
									'text-muted-foreground',
									featured && 'text-primary',
								)}
							/>
							<span className="text-sm">{feature}</span>
						</li>
					))}
				</ul>
			</CardContent>

			<CardFooter className="mt-auto">
				<Button
					asChild
					className={cn(
						'w-full',
						featured
							? 'bg-primary text-primary-foreground hover:bg-primary/90'
							: 'bg-secondary',
					)}
				>
					<Link to={'/signup'}>
						Get started
					</Link>
				</Button>
			</CardFooter>
		</Card>
	)
}
